import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import './schedule-timezone-note.scss';

/**
 * Підпис над календарем: у якому поясі показані години.
 *
 * Малюється ТІЛЬКИ студенту, який обрав не київський пояс (бекенд віддає `timezone_city`
 * лише в цьому випадку) — решті це був би зайвий шум.
 */
const ScheduleTimezoneNote = ({ city, offsetLabel }) => {
  if (!city) {
    return null;
  }

  return (
    <div className="schedule-tz-note">
      <span className="schedule-tz-note__text">
        Час показано за вашим поясом: <b>{city}</b>
        {offsetLabel ? <span className="schedule-tz-note__offset">{offsetLabel}</span> : null}
      </span>

      <Link className="schedule-tz-note__link" to="/settings">Змінити</Link>
    </div>
  );
};

ScheduleTimezoneNote.propTypes = {
  city: PropTypes.string,
  offsetLabel: PropTypes.string,
};

ScheduleTimezoneNote.defaultProps = {
  city: '',
  offsetLabel: '',
};

export default ScheduleTimezoneNote;
